import React from 'react';
import classNames from 'classnames';

import './styles.css';

const DHeader = ({children}) => (
  <div className="DetailsContentWithRightSideBar__Navigation colab-centered-v">
    {children}
  </div>
);

const DLeftSideBar = ({children}) => (
  <div className="DetailsContentWithRightSideBar__leftSideBar">{children}</div>
);

const DContent = ({children}) => (
  <div className="DetailsContentWithRightSideBar__content">{children}</div>
);

const DRightSideBar = ({children}) => (
  <div className="DetailsContentWithRightSideBar__rightSideBar">{children}</div>
);

class DetailsContentWithRightSideBar extends React.Component<{
  className?: string;
}> {
  static Header = DHeader;
  static LeftSideBar = DLeftSideBar;
  static Content = DContent;
  static RightSideBar = DRightSideBar;

  render() {
    const {className} = this.props;

    return (
      <div className={classNames('DetailsContentWithRightSideBar', className)}>
        {this.props.children}
      </div>
    );
  }
}

export default DetailsContentWithRightSideBar;
